import { Component, ViewEncapsulation } from '@angular/core';
import { TekstregelSummaryComponent } from '../tekstregel-summary/tekstregel-summary.component';

@Component({
  selector: 'app-contact-gegevens-summary',
  templateUrl: './../tekstregel-summary/tekstregel-summary.component.html',
  styleUrls: ['./../tekstregel-summary/tekstregel-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContactGegevensSummaryComponent extends TekstregelSummaryComponent {
  constructor() {
    super();
  }
}
